import { Button, DeadlineNote } from '../../design-system/index.js'
import { h2Style, sectionGap, wrap } from '../layout.js'

/**
 * Dark closing panel — the last ask before the footer. The sticky notes in
 * its corners are decorative and desktop-only; on smaller screens there is no
 * margin for them beside the copy.
 */
export function ClosingCta({ t, desktop, authHref, signedIn = false }) {
  return (
    <section
      aria-labelledby="closing-cta-title"
      style={{ ...wrap(desktop), paddingTop: sectionGap(desktop) }}
    >
      <div
        className="u-cta-panel"
        style={{
          padding: desktop ? '72px 64px' : '44px 24px',
          textAlign: 'center',
          color: '#fff',
        }}
      >
        {desktop && (
          <div aria-hidden="true">
            <div style={{ position: 'absolute', left: 40, top: 44 }}>
              <DeadlineNote date="15 Nov" tilt={-6}>
                Chevening
              </DeadlineNote>
            </div>
            <div style={{ position: 'absolute', right: 40, bottom: 40 }}>
              <DeadlineNote date="20 Feb" tilt={5}>
                Türkiye Bursları
              </DeadlineNote>
            </div>
          </div>
        )}

        <div style={{ position: 'relative', maxWidth: 560, margin: '0 auto' }}>
          <h2
            id="closing-cta-title"
            style={{ ...h2Style(desktop), color: '#fff', fontSize: desktop ? 40 : 28 }}
          >
            {t.footT}
          </h2>
          <p style={{ color: 'rgba(255,255,255,.75)', fontSize: 16, margin: '14px 0 28px' }}>
            {t.footS}
          </p>
          <Button size="lg" full={!desktop} href={authHref}>
            {signedIn ? t.openCabinet : t.cta}
          </Button>
        </div>
      </div>
    </section>
  )
}

export default ClosingCta
